import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`
  position: relative;
  z-index: 1001;

  .popup-title {
    width: 100%;
    text-align: center;
    margin-top: 4rem;

    h1 {
      font-weight: 600;
    }
  }

  .model-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
  }

  .add-transfer-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;

    div {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      input {
        width: 100%;
        padding: 1rem;
        border: 1px solid #ddd;
        border-radius: 0.5rem;
        font-size: 1.6rem;

        &:focus {
          outline: none;
          border-color: var(--primary);
        }
      }
    }
  }

  .add-button {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2rem;
  }

  .close-button {
    position: absolute;
    top: 2rem;
    right: 2rem;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 2rem;
      height: 2rem;
    }
  }
`;

export const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  transform: translate(-50%, -50%);
  border-radius: 3rem;
  padding: 1rem;
  background: white;
  overflow: auto;
  outline: none;
  width: 68.5rem;

  @media (max-width: 768px) {
    width: 90%;
    padding: 1.5rem;
  }
`;

